<template>
  <div>
    <h5 v-html="(active+1) +'.'+ data[active].examcont+'（'+ data[active].scores+'分）' "></h5>
    <div v-if="data[active].isvoice == 'Y'">
      <van-cell-group>

      </van-cell-group>
    </div>
    <div v-else-if="data[active].isvideo == 'Y'">
      <van-cell-group>


      </van-cell-group>
    </div>
    <div v-else-if="data[active].isvideo != 'Y' && data[active].isvoice != 'Y'"  >
      <van-cell-group>

      </van-cell-group>
    </div>
    <div  style="height: 100px;width: 100%;padding: .625rem;"  >正确答案：<a v-for="(a,x) in data[active].examan" v-html="a.optioncontent"></a> </div>
    <div  style="height: 100px;width: 100%;padding: .625rem;"  >题目解析：<a v-html="data[active].gradestand"></a> </div>
    <div style="height: 100px;width: 100%" ></div>
  </div>
</template>
<script>


export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      default: 0
    },
    paperId:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      maxlength: 50,
      answer: ''
    }
  },
  methods:
  {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/teacherpage/cuotijicomm/qAndA.vue